import styled from "styled-components";
export const ProjectsCardsSc = styled.div`
  background-color: #e6dddd;
  padding: 25px;
  height: 150px;
  width: 300px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: all 0.3s ease-in-out;
  /* box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1); */

  &:hover {
    transform: translateY(-7px);
    /* box-shadow: 0px 15px 30px rgba(0, 0, 0, 0.2); */
    background-color: #e6dddd;
  }

  div:nth-child(1) {
    margin: 0;
    font-size: 0.9rem;
    font-weight: 600;
    color: #1e59d9;
  }

  div:nth-child(2) {
    font-size: 1rem;
    line-height: 1.5;
    margin-top: 10px;
    color: #333;
  }
`;
